import { render, staticRenderFns } from "./TextPreview.vue?vue&type=template&id=bbba4bbc&"
import script from "./TextPreview.vue?vue&type=script&lang=js&"
export * from "./TextPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports